import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { motion } from 'motion/react'
import { LegalPageElement, useContextPanels } from '../../contexts/panelsContext'
import routePaths from '../../constants/routePaths'
import { useEnv } from '../../utils/useEnv'
import { cn } from '../../utils/cn'
import { buttonResetClassName, separatorClassName } from './classNames'
import { contentVariants } from './menuAnimation'
import legalPages from '../LegalNotice/legalPages'

const footerButtonClassName = cn(
  buttonResetClassName,
  'self-start text-[length:inherit] uppercase short-sm:self-auto',
)

const legalLinkClassName = 'underline underline-offset-2'

// The legal pages, plus the home and language switches that have their own buttons on larger screens
const SideMenuFooter = () => {
  const { openLegalPage, closeAll } = useContextPanels()
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { isKiosk } = useEnv()

  const handleNavigateHome = () => {
    if (location.pathname !== routePaths.HOME) {
      closeAll()
      navigate(routePaths.HOME)
    }
  }

  const changeLanguage = () => {
    i18n.changeLanguage(i18n.language === 'hu' ? 'en' : 'hu')
  }

  return (
    <>
      <motion.hr className={cn(separatorClassName, 'mb-4 md:mb-5')} variants={contentVariants} />
      <motion.div
        className="flex flex-col gap-2.5 text-[12px] md:text-[13px] short-sm:flex-row short-sm:items-center short-sm:gap-6"
        variants={contentVariants}
      >
        <span className="short-sm:mr-auto">
          {t('aboutProject.allRightsReserved', { year: new Date().getFullYear() })}
        </span>
        {location.pathname !== routePaths.HOME ? (
          <button
            type="button"
            className={cn(footerButtonClassName, 'xs:tall-sm:hidden')}
            onClick={handleNavigateHome}
          >
            {t('homePage')}
          </button>
        ) : null}
        <span className="flex gap-4">
          {Object.entries(legalPages).map(([page, { labelKey, link }]) =>
            // the kiosk can't open the museum's site, it shows the page as a QR code instead
            isKiosk ? (
              <button
                key={page}
                type="button"
                className={cn(buttonResetClassName, legalLinkClassName, 'text-[length:inherit]')}
                onClick={() => openLegalPage(page as LegalPageElement)}
              >
                {t(labelKey)}
              </button>
            ) : (
              <a
                key={page}
                className={legalLinkClassName}
                href={link}
                rel="noopener noreferrer"
                target="_blank"
              >
                {t(labelKey)}
              </a>
            ),
          )}
        </span>
        <button
          type="button"
          className={cn(footerButtonClassName, 'xs:tall-sm:hidden')}
          onClick={changeLanguage}
        >
          {t('changeLanguage')}
        </button>
      </motion.div>
    </>
  )
}

export default SideMenuFooter
